var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-animated"},[_vm._t("default",[_c('vcl-code',{attrs:{"primary":_vm.primaryColor,"secondary":_vm.secondaryColor}})],{"primary":_vm.primaryColor,"secondary":_vm.secondaryColor})],2)}
var staticRenderFns = []

export { render, staticRenderFns }